/**
 * [RoleName description]
 * @param {number} value [description]
 */
export function StatusCampaignName(value) {
    switch (value) {
        case 1:
            return "Conectada";
        default:
            return "Desconectada";
    }
}
